var map = {
	"./icon-additional.svg": "4e0a",
	"./icon-bathroom.svg": "9121",
	"./icon-box.svg": "6c96",
	"./icon-decoration.svg": "e405",
	"./icon-door.svg": "7340",
	"./icon-stairs.svg": "5214",
	"./icon-window.svg": "a654"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5402";